/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { format } from "date-fns";
import Swal from "sweetalert2";
import axios from "axios";
import { GET_LISTDATA } from "../../actions";
import Select from "react-select";
import { apiUrl, adminlimit, headerconfig } from "../Settings/Config";
import {
  showContaimerLoader,
  userID,
  showStatus,
  encodeValue,
  showPriceValue,
  showLoader,
  hideLoader,
  checkPermission,
} from "../Settings/Settings";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
var module = "sale/";
var moduleName = "Sale";
var qs = require("qs");
var Parser = require("html-react-parser");
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userID: userID(),
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      name: "",
      status: "",
      selectedItem: "",
      employeeList: [],
      selectedEmp: "",
      assignRemarks: "",
      assignHistory: [],
      amountHistory: [],
      totalAmount: 0,
      activeTab: "form",
      colectamount: "",
      tdsamount:"",
      modeofPayment: "",
      paymentreferencenumber: "",
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    this.loadList(1);
    this.loadEmployee();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        name: "",
        category: "",
        status: "",
      },
      function () {
        this.loadList(1);
      }
    );
  }
  loadEmployee() {
    var urlShringTxt =
      apiUrl + "employee/dropdownlist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ employeeList: res.data.result });
      }
    });
  }
  loadList(offset) {
    var addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    if (
      this.state.status !== null &&
      Object.keys(this.state.status).length > 0
    ) {
      addParams += "&status=" + this.state.status.value;
    }
    var params = {
      params:
        "limit=" +
        adminlimit +
        "&offset=" +
        offset +
        "&userID=" +
        this.state.userID +
        addParams,
      url: apiUrl + module + "list",
    };
    this.props.getListData(params);
  }
  edit(editID) {
    this.props.history.push({
      pathname: "/" + module + "edit",
      state: { editID: encodeValue(editID) },
    });
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    }
  };
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }

  handleChangeRemarks(historyIndex, event) {
    var assignHistory = this.state.assignHistory;
    var updassignHistory = [];
    if (assignHistory.length > 0) {
      assignHistory.map((item, index) => {
        if (historyIndex === index) {
          var historyDetails = item;
          historyDetails["assignRemarks"] = event.target.value;
          updassignHistory.push(item);
        } else {
          updassignHistory.push(item);
        }
        return "";
      });
    }
    this.setState({ assignHistory: updassignHistory });
  }

  setTab(type) {
    this.setState({ activeTab: type });
  }
  assignEng(item) {
    this.setState({ selectedItem: item }, () => {
      this.getassignEmployee();
      $("#modaldemo1").modal("show");
    });
  }
  getassignEmployee() {
    var urlShringTxt =
      apiUrl +
      module +
      "getassignEmployee?&userID=" +
      this.state.userID +
      "&saleID=" +
      this.state.selectedItem?.saleID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ assignHistory: res.data.result });
      }
    });
  }
  confirmAssing() {
    var postObject = {
      userID: this.state.userID,
      saleID: this.state.selectedItem?.saleID,
      empID: this.state.selectedEmp?.value,
    };
    showLoader("assignEmp");
    axios
      .post(
        apiUrl + "sale/assignEmployee",
        qs.stringify(postObject),
        headerconfig
      )
      .then((res) => {
        hideLoader("assignEmp");
        if (res.data.status === "success") {
          toast.success(res.data.message, { autoClose: 2000 });
          this.setState(
            {
              selectedItem: "",
              selectedEmp: "",
            },
            () => {
              $("#modaldemo1").modal("hide");
              this.getassignEmployee();
            }
          );
        } else if (res.data.status === "error") {
          var errMsg = res.data.message !== "" ? Parser(res.data.message) : "";
          if (errMsg !== "") {
            toast.error(res.data.message, { autoClose: 2000 });
          }
        }
      });
  }
  completeWork(assignID, assignIndex) {
    var assignHistory = this.state.assignHistory;
    var assignRemarks = "";
    if (assignHistory.length > 0) {
      assignHistory.map((item, index) => {
        if (assignIndex === index) {
          assignRemarks = item?.assignRemarks;
        }
        return "";
      });
    }

    var postObject = {
      userID: this.state.userID,
      assignID: assignID,
      assignRemarks: assignRemarks,
    };
    showLoader("assignEmp");
    axios
      .post(
        apiUrl + "sale/updateassignStatus",
        qs.stringify(postObject),
        headerconfig
      )
      .then((res) => {
        hideLoader("assignEmp");
        if (res.data.status === "success") {
          toast.success(res.data.message, { autoClose: 2000 });
          this.getassignEmployee();
        } else if (res.data.status === "error") {
          var errMsg = res.data.message !== "" ? Parser(res.data.message) : "";
          if (errMsg !== "") {
            toast.error(res.data.message, { autoClose: 2000 });
          }
        }
      });
  }
  collectAmount(item) {
    this.setState({ selectedItem: item }, () => {
      $("#modalamount").modal("show");
      this.getamountHistory();
    });
  }
  getamountHistory() {
    var urlShringTxt =
      apiUrl +
      module +
      "getamountHistory?&userID=" +
      this.state.userID +
      "&saleID=" +
      this.state.selectedItem?.saleID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({
          amountHistory: res.data.result,
          totalAmount: res.data.totalAmount,
        });
      }
    });
  }
  confirmCollectAmount() {
    var postObject = {
      userID: this.state.userID,
      saleID: this.state.selectedItem?.saleID,
      amount: this.state.colectamount,
      tdsamount:this.state.tdsamount,
      modeofPayment: this.state.modeofPayment?.value,
      paymentreferencenumber: this.state.paymentreferencenumber,
    };
    showLoader("assigncollect");
    axios
      .post(
        apiUrl + "sale/collectSaleAmount",
        qs.stringify(postObject),
        headerconfig
      )
      .then((res) => {
        hideLoader("assigncollect");
        if (res.data.status === "success") {
          toast.success(res.data.message, { autoClose: 2000 });
          this.setState(
            {
              selectedItem: "",
              colectamount: "",
              tdsamount:"",
              modeofPayment: "",
              paymentreferencenumber: "",
            },
            () => {
              $("#modalamount").modal("hide");
              this.getassignEmployee();
              this.loadList(this.state.currentPage);
            }
          );
        } else if (res.data.status === "error") {
          var errMsg = res.data.message !== "" ? Parser(res.data.message) : "";
          if (errMsg !== "") {
            toast.error(res.data.message, { autoClose: 2000 });
          }
        }
      });
  }

  convertToInvoice(saleID) {
    var $_this = this;
    var formPayload = {
      saleID:saleID,
      userID:this.state.userID
    }
    Swal.fire({
      title: "Are you sure?",
      text: "You want convert to tax invoice this sales!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, convert it!",
      customClass: {
        confirmButton: "btn btn-primary me-3 waves-effect waves-light",
        cancelButton: "btn btn-label-secondary waves-effect",
      },
      buttonsStyling: false,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return axios.post(
          apiUrl + 'sale/converttaxinvoice',
          qs.stringify(formPayload),
          headerconfig
        ).then((res) => {
          return res.data;
        });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (
        result?.value !== "" &&
        typeof result?.value !== undefined &&
        result?.dismiss !== "cancel"
      ) {
        if (result?.value?.status == "success") {
          $_this.loadList($_this.state.currentPage);
          Swal.fire({
            icon: "success",
            title: "Converted!",
            text: result.value.message,
            customClass: {
              confirmButton: "btn btn-success waves-effect",
            },
          });
        } else {
          Swal.fire({
            title: "Alert",
            text: result.value.message,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-danger waves-effect",
            },
          });
        }
      }
    });
  }

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="sale" />
            <ToastContainer />
            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                    {checkPermission("sale", "add") === true && (
                      <div>
                        <ol className="breadcrumb">
                          <li className="breadcrumb-item">
                            <Link to={"/" + module + "create"}>
                              <button
                                className="btn btn-sm btn-success badge"
                                type="button"
                              >
                                <i className="fa fa-plus"></i> Create New
                              </button>
                            </Link>
                          </li>
                        </ol>
                      </div>
                    )}
                  </div>

                  <div className="row">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="form-row">
                            <div className="col-md-3">
                              <input
                                type="text"
                                className="form-control"
                                placeholder={"Search " + moduleName}
                                name="name"
                                onChange={this.handleChangeText}
                                value={this.state.name}
                              />
                            </div>
                            <div className="col-md-3">
                              <a
                                href={() => false}
                                className="btn btn-primary"
                                onClick={this.searchList.bind(this)}
                              >
                                Search
                              </a>
                              <a
                                href={() => false}
                                className="btn btn-secondary offset-1"
                                onClick={this.resetSearch.bind(this)}
                              >
                                Reload
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-12">
                      <div className="card">
                        {this.state.loading ? (
                          showContaimerLoader()
                        ) : (
                          <div>
                            {parseInt(this.state.totalPage) > 0 && (
                              <div className="card-header">
                                <h3 className="card-title">
                                  <b>{this.state.currentPage}</b> -{" "}
                                  <b> {this.state.totalPage}</b> of{" "}
                                  <b> {this.state.totalPage} </b>
                                  {moduleName}
                                </h3>
                              </div>
                            )}
                            <div className="card-body">
                              <div className="table-responsive">
                                <table className="table text-nowrap text-md-nowrap mb-0">
                                  <thead>
                                    <tr>
                                      <th></th>
                                      <th>Sale Number</th>
                                      <th>Type Of Sale</th>
                                      <th>Sale Amount</th>
                                      <th>Balance Amount</th>
                                      <th>Expiry</th>
                                      <th>Customer Name</th>
                                      <th>Contact Person</th>
                                      <th>Mobile </th>
                                      <th>Email</th>
                                      <th>Address</th>
                                      <th>Branch</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {this.state.listdata.length > 0 ? (
                                      this.state.listdata.map((item, index) => {
                                        return (
                                          <tr
                                            key={index}
                                            className={`${
                                              item.balanceDate <= 7 && item.saleType!=='Spot Service' && item.saleType!=='Hardware'
                                                ? "expiry-error"
                                                : ""
                                            } ${
                                              item.saleinvoiceType === "2"
                                                ? "deliverychallan"
                                                : ""
                                            }`}
                                          >
                                            <td>
                                              <a
                                                className="nav-link dropdown-toggle"
                                                data-bs-toggle="dropdown"
                                                href="/"
                                                role="button"
                                                aria-expanded="false"
                                              >
                                                Action
                                              </a>
                                              <ul className="dropdown-menu">
                                                {item.saleinvoiceType === "1" ? (
                                                  <li>
                                                    <Link
                                                      className="dropdown-item"
                                                      to={`/sale/invoice/${encodeValue(
                                                        item.saleID
                                                      )}`}
                                                      target="_blank"
                                                    >
                                                      View Tax Invoice
                                                    </Link>
                                                  </li>
                                                ) : (
                                                  item.saleinvoiceType === "3" ? (
                                                  <li>
                                                    <Link
                                                      className="dropdown-item"
                                                      to={`/sale/proforma-invoice/${encodeValue(
                                                        item.saleID
                                                      )}`}
                                                      target="_blank"
                                                    >
                                                      View Proforma Invoice
                                                    </Link>
                                                  </li>
                                                ):(
                                                  <li>
                                                    <Link
                                                      className="dropdown-item"
                                                      to={`/sale/deliverychallan/${encodeValue(
                                                        item.saleID
                                                      )}`}
                                                      target="_blank"
                                                    >
                                                      View Delivery Challan
                                                    </Link>
                                                  </li>)
                                                )}
                                                {item.saleinvoiceType === "3" && (
                                                  <li>
                                                    <a
                                                    className="dropdown-item"
                                                    href={() => false}
                                                    onClick={this.convertToInvoice.bind(
                                                      this,
                                                      item.saleID
                                                    )}
                                                  >
                                                      Convert To Tax Invoice
                                                    </a>
                                                  </li>
                                                )}
                                                {item.saleinvoiceType ===
                                                  "2" && (
                                                  <li>
                                                    <Link
                                                      className="dropdown-item"
                                                      to={`/sale/convertsale/${encodeValue(
                                                        item.saleID
                                                      )}`}
                                                    >
                                                      Convert To Sale
                                                    </Link>
                                                  </li>
                                                )}
                                                <li>
                                                  <a
                                                    className="dropdown-item"
                                                    href={() => false}
                                                    onClick={this.assignEng.bind(
                                                      this,
                                                      item
                                                    )}
                                                  >
                                                    Assign Engineer
                                                  </a>
                                                </li>
                                                <li>
                                                  <a
                                                    className="dropdown-item"
                                                    href={() => false}
                                                    onClick={this.collectAmount.bind(
                                                      this,
                                                      item
                                                    )}
                                                  >
                                                    Add Amount
                                                  </a>
                                                </li>
                                                {item.balanceDate <= 7 && item.saleType!=='Spot Service'  && (
                                                  <li>
                                                    <Link
                                                      className="dropdown-item"
                                                      to={`/sale/renewal/${encodeValue(
                                                        item.saleID
                                                      )}`}
                                                    >
                                                      {item.saleType ===
                                                      "Hardware"
                                                        ? "Convert To AMC / CMS"
                                                        : "Renewal"}
                                                    </Link>
                                                  </li>
                                                )}
                                              </ul>
                                            </td>
                                            <td>{item.saleNumber}</td>
                                            <td>{item.saleType}</td>
                                            <td>
                                              {showPriceValue(item.salePrice)}
                                            </td>
                                            <td>
                                              {showPriceValue(
                                                item.saleBalanceAmount
                                              )}
                                            </td>
                                            <td>
                                              {item.saleType!=='Spot Service'  && item.saleType!=='Hardware' ? format(
                                                new Date(item.endDate),
                                                "dd-MM-yyyy"
                                              ):'-'}
                                              {item.balanceDate <= 7 && item.saleType!=='Spot Service'  && item.saleType!=='Hardware' &&  (
                                                <>
                                                  <br />
                                                  {item.balanceDate > 0 &&
                                                    item.balanceDate}{" "}
                                                  {item.balanceDate > 0
                                                    ? "left"
                                                    : "Expired"}
                                                </>
                                              )}
                                            </td>
                                            <td>{item.customerName}</td>
                                            <td>
                                              {item.customerContactPerson}
                                            </td>
                                            <td>{item.customerMobile}</td>
                                            <td>{item.customerEmail}</td>
                                            <td>
                                              {item.customerAddress1}
                                              {item.customerAddress2 !== "" &&
                                                item.customerAddress2 !==
                                                  null && (
                                                  <>, {item.customerAddress2}</>
                                                )}
                                              {item.customerState !== "" &&
                                                item.customerState !== null && (
                                                  <>, {item.customerState}</>
                                                )}
                                              {item.customerPincode !== "" &&
                                                item.customerPincode !==
                                                  null && (
                                                  <> - {item.customerPincode}</>
                                                )}
                                            </td>
                                            <td>{item.customerBranch}</td>
                                            <td>
                                              {showStatus(item.empStatus)}
                                            </td>
                                          </tr>
                                        );
                                      })
                                    ) : (
                                      <tr>
                                        <td
                                          className="text-center"
                                          colSpan={12}
                                        >
                                          No {moduleName} Found
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                              <Pagenation
                                params={{
                                  totalRecords: this.state.totalRecords,
                                  totalPage: this.state.totalPage,
                                  currentPage: this.state.currentPage,
                                }}
                                sateValChange={this.sateValChange}
                              />
                             
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal fade" id="modaldemo1">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content modal-content-demo">
              <div className="modal-header">
                <h6 className="modal-title">Assign Engineer</h6>
                <button
                  aria-label="Close"
                  className="btn-close"
                  data-bs-dismiss="modal"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="tab-menu-heading">
                  <div className="tabs-menu">
                    <ul className="nav panel-tabs panel-info">
                      <li>
                        <a
                          href="#tab21"
                          className="active"
                          data-bs-toggle="tab"
                          onClick={this.setTab.bind(this, "form")}
                        >
                          <span>
                            <i className="fe fe-user me-1"></i>
                          </span>
                          New
                        </a>
                      </li>
                      <li>
                        <a
                          href="#tab22"
                          data-bs-toggle="tab"
                          onClick={this.setTab.bind(this, "list")}
                        >
                          <span>
                            <i className="fe fe-calendar me-1"></i>
                          </span>
                          Assigning History
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                {this.state.activeTab === "form" && (
                  <div className="form-row mt-4">
                    <div className="form-group col-md-12">
                      <label className="form-label">
                        Select Engineer<span className="lbl-error">*</span>
                      </label>
                      <Select
                        value={this.state.selectedEmp}
                        onChange={this.handleSelectChange.bind(
                          this,
                          "selectedEmp"
                        )}
                        placeholder="Select Engineer"
                        isClearable={true}
                        options={this.state.employeeList}
                      />
                    </div>
                  </div>
                )}
                {this.state.activeTab === "list" && (
                  <div className="table-responsive mt-4">
                    <table className="table text-nowrap text-md-nowrap mb-0">
                      <thead>
                        <tr>
                          <th>Engineer Name</th>
                          <th>Engineer ID</th>
                          <th>Assign Date</th>
                          <th>Status</th>
                          <th>Completed Date</th>
                          <th>Remarks</th>
                          <th className="text-center">Actions </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.assignHistory.length > 0 ? (
                          this.state.assignHistory.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>{item.empName}</td>
                                <td>{item.employeeID}</td>
                                <td>
                                  {format(
                                    new Date(item.assignDate),
                                    "dd-MM-yyyy"
                                  )}
                                </td>
                                <td>{item.assignStatus}</td>
                                <td>
                                  {item.assignCompletedOn !== "" &&
                                    item.assignCompletedOn !== null &&
                                    format(
                                      new Date(item.assignDate),
                                      "dd-MM-yyyy"
                                    )}
                                </td>
                                <td>
                                  {item.assignStatus === "Completed" ? (
                                    item.assignRemarks
                                  ) : (
                                    <textarea
                                      className="form-control"
                                      placeholder="Please Enter Remarks"
                                      name="assignRemarks"
                                      style={{ width: "200px" }}
                                      onChange={this.handleChangeRemarks.bind(
                                        this,
                                        index
                                      )}
                                      rows={5}
                                      cols={5}
                                    >
                                      {this.state.remarks}
                                    </textarea>
                                  )}
                                </td>
                                <td>
                                  {item.assignStatus !== "Completed" && (
                                    <a
                                      href={() => false}
                                      className="btn btn-info"
                                      onClick={this.completeWork.bind(
                                        this,
                                        item.assignID,
                                        index
                                      )}
                                    >
                                      Complete
                                    </a>
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td className="text-center" colSpan={5}>
                              No Record Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-primary"
                  onClick={this.confirmAssing.bind(this)}
                  id="assignEmp"
                >
                  Assign
                </button>{" "}
                <button className="btn btn-light" data-bs-dismiss="modal">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="modalamount">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content modal-content-demo">
              <div className="modal-header">
                <h6 className="modal-title">Collect Amount</h6>
                <button
                  aria-label="Close"
                  className="btn-close"
                  data-bs-dismiss="modal"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="tab-menu-heading">
                  <div className="tabs-menu">
                    <ul className="nav panel-tabs panel-info">
                      <li>
                        <a
                          href="#tab21"
                          className="active"
                          data-bs-toggle="tab"
                          onClick={this.setTab.bind(this, "form")}
                        >
                          <span>
                            <i className="fe fe-user me-1"></i>
                          </span>
                          New
                        </a>
                      </li>
                      <li>
                        <a
                          href="#tab22"
                          data-bs-toggle="tab"
                          onClick={this.setTab.bind(this, "list")}
                        >
                          <span>
                            <i className="fe fe-calendar me-1"></i>
                          </span>
                          History
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                {this.state.activeTab === "form" && (
                  <div className="form-row mt-4">
                    <div className="form-group col-md-3">
                      <label className="form-label">
                        Amount<span className="lbl-error">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Please Enter Amount"
                        name="colectamount"
                        autoComplete="off"
                        onChange={this.handleChangeText}
                        value={this.state.colectamount}
                      />
                    </div>
                    <div className="form-group col-md-3">
                      <label className="form-label">
                        TDS Amount
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Please Enter Amount"
                        name="tdsamount"
                        autoComplete="off"
                        onChange={this.handleChangeText}
                        value={this.state.tdsamount}
                      />
                    </div>
                    <div className="form-group col-md-5">
                      <label className="form-label">
                        Mode of Payment<span className="lbl-error">*</span>
                      </label>
                      <Select
                        value={this.state.modeofPayment}
                        onChange={this.handleSelectChange.bind(
                          this,
                          "modeofPayment"
                        )}
                        placeholder="Select Mode of Payment"
                        isClearable={true}
                        options={[
                          {
                            label: "NIFFT",
                            value: "NIFFT",
                          },
                          {
                            label: "Cheque",
                            value: "Cheque",
                          },
                          {
                            label: "Cash",
                            value: "Cash",
                          },
                        ]}
                      />
                    </div>
                    {(this.state.modeofPayment?.value === "NIFFT" ||
                      this.state.modeofPayment?.value === "Cheque") && (
                      <div className="form-group col-md-6">
                        <label className="form-label">
                          Payment Reference Number
                          <span className="lbl-error">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Payment Reference Number"
                          name="paymentreferencenumber"
                          autoComplete="off"
                          onChange={this.handleChangeText}
                          value={this.state.paymentreferencenumber}
                        />
                      </div>
                    )}
                  </div>
                )}
                {this.state.activeTab === "list" && (
                  <div className="table-responsive mt-4">
                    <table className="table text-nowrap text-md-nowrap mb-0">
                      <thead>
                        <tr>
                          <th>Collected Date</th>
                          <th>Amount</th>
                          <th>TDS Amount</th>
                          <th>Mode of Payment</th>
                          <th>Payment Reference Number</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.amountHistory.length > 0 ? (
                          <>
                            {this.state.amountHistory.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    {format(
                                      new Date(item.amountCreatedOn),
                                      "dd-MM-yyyy"
                                    )}
                                  </td>
                                  <td>{showPriceValue(item.amount)}</td>
                                  <td>{showPriceValue(item.TDSamount)}</td>
                                  <td>{item.modeofPayment}</td>
                                  <td>{item.paymentReferenceNumber}</td>                                  
                                </tr>
                              );
                            })}
                            <tr>
                              <td colSpan={4}>
                                <b>Total</b>
                              </td>
                              <td>
                                <b>{showPriceValue(this.state.totalAmount)}</b>
                              </td>
                            </tr>
                          </>
                        ) : (
                          <tr>
                            <td className="text-center" colSpan={4}>
                              No Record Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-primary"
                  onClick={this.confirmCollectAmount.bind(this)}
                  id="assigncollect"
                >
                  Update
                </button>{" "}
                <button className="btn btn-light" data-bs-dismiss="modal">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = [];
  var totalPages = 0;
  var totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(List);
